import React from 'react';
import PropTypes from 'prop-types';

function PageHeader({
  title,
  subtitle,
  action,
}) {
  let subTitleElement;
  let titleElement;

  if (subtitle) {
    subTitleElement = (
      <small className="text-muted">
        &raquo;
        {subtitle}
      </small>
    );
  }

  if (title) {
    titleElement = (
      <h1>
        {title}
        {' '}
        {subTitleElement}
      </h1>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="float-right">
          {action}
        </div>

        {titleElement}
      </div>
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  action: PropTypes.node,
};

PageHeader.defaultProps = {
  title: null,
  subtitle: null,
  action: null,
};

export default PageHeader;
